var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "ugc-tray-wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$store.state.utils.trayDisabled.swatches,
      expression: "$store.state.utils.trayDisabled.swatches"
    }],
    staticClass: "disable-swatches"
  }), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: ['ugc-tray-wrapper-content medium-8 large-6 large-offset-3', {
      columns: !_vm.enableSwiper
    }]
  }, [_vm.enableSwiper ? _c('div', {
    key: "ugc-buttons-swiper",
    staticClass: "ugc-tray-wrapper-swiper-wrapper"
  }, [_c('swiper', {
    ref: "swiper",
    attrs: {
      "options": _vm.swiperOptions
    }
  }, _vm._l(_vm.ugcButtonsOrder, function (featureName, index) {
    return _c('swiper-slide', {
      key: index
    }, [featureName === 'add-your-image' && _vm.hasUgc ? _c('ugc-image-upload', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: false,
        expression: "false"
      }],
      staticClass: "text-center",
      attrs: {
        "disableButton": !_vm.ugc_allowed
      },
      on: {
        "click": _vm.setDataLayer
      }
    }) : _vm._e(), _c(_vm.getComponent(featureName), _vm._g(_vm._b({
      tag: "component"
    }, 'component', _vm.getAttributes(featureName), false), _vm.getEvents(featureName)))], 1);
  }), 1)], 1) : _c('div', {
    key: "ugc-buttons-no-swiper",
    staticClass: "row"
  }, _vm._l(_vm.ugcButtonsOrder, function (featureName, index) {
    return _c('div', {
      key: index,
      class: ['columns ugc-tray-wrapper-column small-8', _vm.buttonCount < 3 ? 'medium-4 large-3' : 'medium-2', {
        'small-centered': _vm.buttonCount === 1,
        'ugc-tray-wrapper-column--first': index === 0 && _vm.buttonCount > 1,
        'ugc-tray-wrapper-column--last': index === _vm.buttonCount - 1 && _vm.buttonCount > 1
      }]
    }, [featureName === 'add-your-image' && _vm.hasUgc ? _c('ugc-image-upload', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: false,
        expression: "false"
      }],
      ref: "hiddenImageUpload",
      refInFor: true,
      staticClass: "text-center",
      attrs: {
        "disableButton": !_vm.ugc_allowed
      },
      on: {
        "click": _vm.setDataLayer
      }
    }) : _vm._e(), _c(_vm.getComponent(featureName), _vm._g(_vm._b({
      key: _vm.ugcLastUpdated,
      tag: "component"
    }, 'component', _vm.getAttributes(featureName), false), _vm.getEvents(featureName)))], 1);
  }), 0)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }